(function(){
  function init(scope=document){
    const root = scope.querySelector('#faq-acc');
    if(!root) return;

    const items = [...root.querySelectorAll('.razor-for-men-accordion__item')];
    const triggers = items.map(i => i.querySelector('.razor-for-men-accordion__trigger'));

    triggers.forEach(btn => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.razor-for-men-accordion__item');
        const willOpen = !item.classList.contains('is-open');

        items.forEach(i => {
          i.classList.remove('is-open');
          const t = i.querySelector('.razor-for-men-accordion__trigger');
          const c = i.querySelector('.razor-for-men-accordion__content');
          if (t) t.setAttribute('aria-expanded','false');
          if (c) c.setAttribute('aria-hidden','true');
        });

        if (willOpen){
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded','true');
          item.querySelector('.razor-for-men-accordion__content').setAttribute('aria-hidden','false');
        }
      });
    });

    const search = scope.querySelector('.razor-for-men-faqs__search input');
    if (search){
      search.addEventListener('input', e => {
        const q = e.target.value.toLowerCase().trim();
        items.forEach(i => {
          const label = i.querySelector('.razor-for-men-accordion__trigger span')?.textContent.toLowerCase() || '';
          const content = i.querySelector('.razor-for-men-accordion__inner')?.textContent.toLowerCase() || '';
          i.style.display = (label.includes(q) || content.includes(q)) ? '' : 'none';
        });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', e => init(e.target));
})();